module.exports = __webpack_public_path__ + "media/images/patent/y_11-eba65011f93df1b39ee4f99ee51f5953.jpg";